import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://api-eventos-legado.uzerpass.com.br/api',
  //baseURL: 'https://hml-api-eventos-legado.uzerpass.com.br/api',  
  ////baseURL: 'http://localhost/BUzer.Acesso/api',  
  ////baseURL: 'https://luxsolucoes.com.br/BUzer-Acesso/api',
  //baseURL: 'http://localhost:5243/api'  
});

export default instance;